// libraries
import React, { useState, useContext, useEffect, useLayoutEffect } from "react";
import { toast } from "react-toastify";
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
} from "react-google-places-autocomplete";

// styles
import styles from "./styles.module.scss";

// assets
import SearchIcon from "../../../../../assets/images/create-event/search.svg";
import currentLocation from "../../../../../assets/images/create-event/current_location.svg";

// utils
import { keys } from "src/utils/keys";

// context
import UserContext from "src/context/User";

// data
import data from "src/utils/data";

const Location = ({ formData, setFormData, toggleModal }) => {
  // context
  const { user } = useContext(UserContext);

  // state
  const [active, setActive] = useState(null);
  const [search, setSearch] = useState(null);

  useLayoutEffect(() => {
    setActive(formData?.eventLocation || null);
  }, []);

  useEffect(() => {
    if (search !== null && search !== "") {
      geocodeByPlaceId(search.value.place_id)
        .then((res) => {
          let lat = res[0].geometry.location.lat();
          let lng = res[0].geometry.location.lng();

          setActive({
            name: search.label,
            lat,
            lng,
          });
        })
        .catch((err) => console);
    }
  }, [search]);

  // handle click
  const handleClick = () => {
    setFormData({
      ...formData,
      eventLocation: active,
    });

    toggleModal(false);
  };

  console.log(active);

  return (
    <div onClick={(e) => e.stopPropagation()} className={styles.location}>
      <h3>Add Location</h3>
      <div className={`create-event-input-wrapper ${styles.search}`}>
        <img src={SearchIcon} alt="search" />
        {/* <input
          placeholder="Select Event Location"
          type="search"
          value={locationSearch}
          onChange={(e) => setLocationSearch(e.target.value)}
        /> */}
        <GooglePlacesAutocomplete
          apiKey={keys.google_api_key}
          selectProps={{
            search,
            onChange: setSearch,
          }}
        />
      </div>
      <div
        className={`${styles.current_location} ${
          active?.name === user?.location?.city ||
          active?.city === user?.location?.city
            ? styles.active
            : ""
        }`}
        onClick={() => {
          setActive({
            ...user?.location,
            name: user?.location?.city,
            // name: "New Haven",
          });
        }}
      >
        <img src={currentLocation} alt="current_location" />
        <div>
          <h6>Use current location</h6>
          <p>{user?.location?.city}</p>
        </div>
      </div>
      {/* <div className={styles.states}>
        <h6>Choose State</h6>
        <div className={styles.list}>
          {data.states.map((item, index) => (
            <p
              key={index}
              onClick={() => {
                setActive(item);
              }}
              className={item.name === active?.name ? styles.active : ""}
            >
              {item.name}
            </p>
          ))}
        </div>
      </div> */}
      <div className={styles.btns}>
        <button onClick={() => toggleModal(false)}>Cancel</button>
        <button onClick={handleClick}>Add</button>
      </div>
    </div>
  );
};

export default Location;
